module.exports = __webpack_public_path__ + "img/rocking-chairs-02.a7b8459b.jpeg";